import React from 'react';
import { useState, useRef } from 'react';
import { useEffect } from 'react';
import lock from '../../assets/img/lock.svg';
import carbrand from '../../assets/img/carshonda.jpg';
import appstore from '../../assets/img/appstore.png';
import googleplay from '../../assets/img/googleplay.png';
import speedometer from '../../assets/img/speedometer.svg';
import gasolinePump from '../../assets/img/gasoline-pump.svg';
import car from '../../assets/img/car.svg';
import book from '../../assets/img/book.svg';
import barcode from '../../assets/img/barcode.svg';
import tag from '../../assets/img/tag.svg';
import Path from '../../assets/img/Path.svg';
import transmission from '../../assets/img/manual-transmission.svg';
import drivetrain from '../../assets/img/drivetrain.svg';
import cars01 from '../../assets/img/cars01.png';
import carshonda from '../../assets/img/carshonda.jpg';
import persent from '../../assets/img/persent.svg';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import API from "../../Services/BaseService";
import GatePassAccept from "../../Container/History/GatePassAccept";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import Loading from "../../Component/Loading/Loading";
import Popup from "../../Component/Popup/Popup";
import Barcode from "react-barcode";
import ls from 'local-storage';
import PageNotFound from '../FallBackUI/PageNotFound';
import moment from 'moment';
import UrCarBidList from "../../../src/Container/UrCardetails/UrBidlist";
import UrCarProxyList from "../../../src/Container/UrCardetails/UrCarProxyBid";
import miles from '../../assets/img/miles.jpg';
import 'bootstrap/dist/css/bootstrap.min.css';
import { OverlayTrigger, Popover, Button } from 'react-bootstrap';

const CarDetails = (props) => {
	const successData = useSelector(state => state.LoginReducer.payload);
	const history = useHistory();
	const [loading, setLoading] = useState(true);
	const [gatepasscode, setGatePassCode] = useState("");
	const [carId, setCarId] = useState(null);
	const [buyerId, setBuyerId] = useState(null);
	const [isOpenAccept, setIsOpensAccept] = useState(false);
	const [feeDetails, setFeeDetails] = useState("");
	const [isShown, setIsShown] = useState(false);
	const [isShowngp, setIsShowngp] = useState(false);

	const [carDetail, setCarDetail] = useState([]);
	const [lrgImg, setLrgImg] = useState("");
	const [lrgVideo, setLrgVideo] = useState("");
	const [isVideoFlag, setIsVideoFlag] = useState(false);
	const [distance, setDistance] = useState("");
	const [copied, setCopied] = useState(false);
	const [isOpenBidList, setisOpenBidList] = useState(false);
	const [isOpenProxyList, setisOpenProxyList] = useState(false);
	const [copySuccess, setCopySuccess] = useState('');
	const sellerData = useSelector(state => state.LoginReducer.payload);
	const dealerData = useSelector(state => state.DealerReducer.payload);

	// const { backURL, id, transportationFlag } = props.location.state;

	console.log("check the props value", props.location.state);

	const [errors, setErrors] = useState("");
	const [errorFlag, setErrorFlag] = useState(false);
	const { useRef } = React;
	const [cardMagnifier, setCardMagnifier] = useState({
		show: false, x: 0, y: 0, imgX: 0, imgY: 0, activeId: null
	});

	const handleMouseMove = (e, id) => {
		const rect = e.currentTarget.getBoundingClientRect();
		const x = e.clientX - rect.left;
		const y = e.clientY - rect.top;
		setCardMagnifier({
			show: true, x, y,
			imgX: (x / rect.width) * 100,
			imgY: (y / rect.height) * 100,
			activeId: id
		});
	};

	const handleMouseLeave = () => {
		setCardMagnifier(prev => ({ ...prev, show: false, activeId: null }));
	};

	// Slider scroll
	const sliderRef = useRef(null);
	const scrollUp = () => sliderRef.current.scrollBy({ top: -110, behavior: "smooth" });
	const scrollDown = () => sliderRef.current.scrollBy({ top: 110, behavior: "smooth" });
	const [isPopupOpen, setIsPopupOpen] = useState(false);
	const [popupImages, setPopupImages] = useState([]);
	const [currentImageIndex, setCurrentImageIndex] = useState(0);

	const handleNextImage = () => {
		if (currentImageIndex < popupImages.length - 1) {
			setCurrentImageIndex(currentImageIndex + 1);
		}
	};

	const handlePrevImage = () => {
		if (currentImageIndex > 0) {
			setCurrentImageIndex(currentImageIndex - 1);
		}
	};

	const isValidMediaUrl = (url) => {
		if (!url) return false;
		const invalidPatterns = ['placeholder', 'default-image', 'no-image', 'coming-soon'];
		const hasInvalidPattern = invalidPatterns.some(pattern =>
			url.toLowerCase().includes(pattern.toLowerCase())
		);
		return !hasInvalidPattern && url.trim() !== '';
	};

	const handleImageClick = (clickedImageUrl, clickedIndex) => {
		const allImages = [];
		if (carDetail[0]?.carimage && isValidMediaUrl(carDetail[0].carimage)) {
			allImages.push({ image: carDetail[0].carimage, format: "image", id: "main" });
		}
		carDetail.slice(1).forEach(item => {
			if (isValidMediaUrl(item.carimage)) {
				allImages.push({
					image: item.carimage,
					format: item.format || "image",
					id: item.car_images_id
				});
			}
		});
		if (allImages.length === 0) return;
		setPopupImages(allImages);
		setCurrentImageIndex(clickedIndex || 0);
		setIsPopupOpen(true);
	};
	const PopupMagnifier = ({ images, currentIndex, onClose, onNext, onPrev }) => {
		const [magnifierPos, setMagnifierPos] = useState({ show: false, x: 0, y: 0, imgX: 0, imgY: 0 });
		const [imgError, setImgError] = useState(false);
		const containerRef = useRef(null);
		const imgRef = useRef(null);
		const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });

		const currentImage = images[currentIndex];

		const handleMouseMove = (e) => {
			if (!containerRef.current || !imgRef.current) return;
			const imgRect = imgRef.current.getBoundingClientRect();
			const containerRect = containerRef.current.getBoundingClientRect();
			if (
				e.clientX < imgRect.left || e.clientX > imgRect.right ||
				e.clientY < imgRect.top || e.clientY > imgRect.bottom
			) {
				setMagnifierPos(prev => ({ ...prev, show: false }));
				return;
			}
			const x = e.clientX - containerRect.left;
			const y = e.clientY - containerRect.top;
			const imgX = ((e.clientX - imgRect.left) / imgRect.width) * 100;
			const imgY = ((e.clientY - imgRect.top) / imgRect.height) * 100;
			setMagnifierPos({ show: true, x, y, imgX, imgY });
		};

		const handleMouseLeave = () => setMagnifierPos(prev => ({ ...prev, show: false }));
		const handleImageError = () => setImgError(true);
		const handleImageLoad = (e) => {
			if (e.target) {
				setImageDimensions({ width: e.target.naturalWidth, height: e.target.naturalHeight });
			}
		};

		useEffect(() => {
			const handleKeyDown = (e) => {
				if (e.key === 'ArrowLeft') onPrev();
				else if (e.key === 'ArrowRight') onNext();
				else if (e.key === 'Escape') onClose();
			};
			window.addEventListener('keydown', handleKeyDown);
			return () => window.removeEventListener('keydown', handleKeyDown);
		}, [onPrev, onNext, onClose]);

		useEffect(() => {
			setImgError(false);
			setMagnifierPos({ show: false, x: 0, y: 0, imgX: 0, imgY: 0 });
		}, [currentIndex]);

		if (!currentImage) return null;

		const magnifierSize = window.innerWidth <= 768 ? 150 : 200;
		const zoomScale = 3;

		return (
			<div className="image-popup-overlay" onClick={onClose}>
				<div className="image-popup-content" onClick={(e) => e.stopPropagation()}>
					<button className="popup-close-btn" onClick={onClose}>×</button>

					{currentIndex > 0 && (
						<button className="popup-nav-btn popup-prev-btn" onClick={(e) => { e.stopPropagation(); onPrev(); }}>
							&#10094;
						</button>
					)}
					{currentIndex < images.length - 1 && (
						<button className="popup-nav-btn popup-next-btn" onClick={(e) => { e.stopPropagation(); onNext(); }}>
							&#10095;
						</button>
					)}

					<div className="popup-image-counter">
						{currentIndex + 1} / {images.length}
					</div>

					<div
						ref={containerRef}
						className="popup-image-container"
						onMouseMove={currentImage.format === "image" ? handleMouseMove : undefined}
						onMouseLeave={currentImage.format === "image" ? handleMouseLeave : undefined}
					>
						{imgError ? (
							<div className="popup-image-error">
								<p>Image failed to load</p>
								<button onClick={onClose}>Close</button>
							</div>
						) : (
							<>
								{currentImage.format === "image" || !currentImage.format ? (
									<img
										ref={imgRef}
										src={currentImage.image}
										alt="Popup"
										className="popup-image"
										onError={handleImageError}
										onLoad={handleImageLoad}
										draggable={false}
									/>
								) : (
									<video controls className="popup-video" autoPlay={false}>
										<source src={currentImage.image} type="video/mp4" />
									</video>
								)}
							</>
						)}

						{!imgError && (currentImage.format === "image" || !currentImage.format) && (
							<div
								className="popup-magnifier"
								style={{
									display: magnifierPos.show ? 'block' : 'none',
									left: `${magnifierPos.x}px`,
									top: `${magnifierPos.y}px`,
									width: `${magnifierSize}px`,
									height: `${magnifierSize}px`,
									backgroundImage: `url(${currentImage.image})`,
									backgroundPosition: `${magnifierPos.imgX}% ${magnifierPos.imgY}%`,
									backgroundSize: imgRef.current
										? `${imgRef.current.getBoundingClientRect().width * zoomScale}px ${imgRef.current.getBoundingClientRect().height * zoomScale}px`
										: `${zoomScale * 100}% ${zoomScale * 100}%`,
									backgroundRepeat: 'no-repeat',
								}}
							/>
						)}
					</div>
				</div>
			</div>
		);
	};
	let id = ""
	let transportationFlag = ""
	let backURL = ""

	let car_Id = ls.get("mailViaSoldCarId")

	let BillOfSale = ls.get("BillofSaleId")

	const backUrl = ls.get("backredirection");
	console.log("check the back url", backUrl);
	const back = backUrl[(backUrl.length) - 1];
	console.log("checking the ls.set", backUrl[(backUrl.length) - 1]);

	console.log("mailViaSoldCarId details", car_Id);

	if (car_Id === "" || car_Id === null || car_Id === "null" || car_Id === undefined || car_Id === "undefined") {
		id = props.location.state.id;
		transportationFlag = props.location.state.transportationFlag;
		backURL = props.location.state.backURL;
	}
	else {
		id = car_Id;
		transportationFlag = "";
		backURL = "/carlist"
	}

	// const selectedCarDetails = useSelector(state => state.CarListReducer.payload);
	console.log("===sellerData===", sellerData)
	// console.log("===selectedCarDetails===",selectedCarDetails)
	const gatepassColorChange = () => {
		console.log("gate passColor Change")

		getsoldcar(dealerData);
	}
	const handleCounter = () => {
		setLoading(true)
		getsoldcar(dealerData);
	}
	function getsoldcar(data) {
		console.log("soldcar interval");
		const request = {
			car_id: id,
			// "buyer_dealer_id": JSON.parse(localStorage.getItem("userDetails")).buyer_dealer_id,
			// "seller_dealer_id": selectedSellerId 
			seller_dealer_id: data == undefined || data === null ? sellerData.seller_dealer_id : data.seller_dealer_id,
			// seller_dealer_id: sellerData.seller_dealer_id,
			seller_id: sellerData.seller_id,
			seller_token: sellerData.seller_token,

		}
		console.log("request for sold car detail", request)
		API.post('carDetails/condition', request).then(res => {
			console.log("sold car details response", res.data.data);
			// console.log("Response data",res.data.data);

			if (res.data.success === true) {
				setLoading(false);
				let merged = []
				for (let i = 0; i < res.data.data.length; i++) {
					merged.push({
						...res.data.data[i], ...(res.data.data1.find((item) => item.car_id === res.data.data[i].car_id))
					})
				}
				console.log("merged", merged);
				setCarDetail(merged)
				// setCarDetail(res.data.data);
				console.log("car Detail", res.data.data);
				console.log("car distance added", res.data.distance);
				setDistance(res.data.distance);
				setLrgImg(res.data.data[0]?.carimage);
				setLrgVideo(res.data.data[0].carimage);
				setIsVideoFlag(false)

			}
			else {
				setErrors(res.data.error)
				setErrorFlag(true)
			}

		})
			.catch(function (error) {
				if (error.response) {
					setErrors(error.response.data.error)
					setErrorFlag(true)
				}
			});
	}
	const togglePopupAccept = () => {
		setIsOpensAccept(!isOpenAccept);
	}

	const togglePopupBidList = () => {
		setisOpenBidList(!isOpenBidList);
	}
	const togglePopupProxyList = () => {
		setisOpenProxyList(!isOpenProxyList);
	}
	const gatePass = (carDetail) => {
		setCarId(carDetail.car_id);
		setBuyerId(carDetail.buyer_dealer_id)
		togglePopupAccept()
	}

	function copytoclipboard(e) {
		document.execCommand('copy');
		e.target.focus();
		setCopySuccess('Copied!');
	};

	function img1Click(img) {
		loadLrgImg(img.target.src);
		setIsVideoFlag(false)

	}
	function img2Click(img, item) {
		// console.log("values passed", img);
		loadLrgImg(img.target.src);
		setIsVideoFlag(false)

	}
	function img3Click(img, item) {

		loadLrgImg(img.target.src);
		setIsVideoFlag(false)

	}
	function img4Click(src) {
		loadLrgImg(src);
		setIsVideoFlag(false)

	}

	function loadLrgImg(img) {
		setLrgImg(img);
	}

	function video1Click(video) {
		largeVideoLoad(video)
		setIsVideoFlag(true)
	}
	function video2Click(video) {
		largeVideoLoad(video);
		setIsVideoFlag(true)
	}

	function video3Click(video) {
		largeVideoLoad(video);
		setIsVideoFlag(true)
	}

	function video4Click(video) {
		largeVideoLoad(video);
		setIsVideoFlag(true)
	}

	function largeVideoLoad(video) {
		setLrgVideo(video);
	}


	/* useEffect(() => {
		let intervalId;
		intervalId = setInterval(() => {
			   getrecentlycar();
			   getallcar();
			getsoldcar(dealerData);
		}, 30000)	
		return () => clearInterval(intervalId);
	}, []) */
	useEffect(() => {
		setLoading(true)
		getsoldcar(dealerData);
	}, [id])

	const config = {
		background: "#f5f5f5",
		displayValue: false,
		marginTop: "20px",
		marginBottom: "20px",
		fontOptions: "italic",
		width: 2,
		heigth: 5
	};

	async function fetchBuyerFees(data) {
		console.log("inside fn");
		let request = {
			type: "Seller",
			// seller_dealer_id: successData.seller_dealer_id,
			seller_dealer_id: data == undefined || data === null ? sellerData.seller_dealer_id : data.seller_dealer_id,

			seller_id: successData.seller_id,
			seller_token: successData.seller_token

		};
		const state = API.post('sellerFees/condition', request);
		state.then(res => {
			console.log("res", res)
			if (res.data.success === true) {
				setFeeDetails(res.data.data);
				// setLoading(false);
			}
			else {
				setErrors(res.data.error)
				setErrorFlag(true)
			}

		})
			.catch(function (error) {
				if (error.response) {
					setErrors(error.response.data.error)
					setErrorFlag(true)
				}
			});
	}

	useEffect(() => {

		fetchBuyerFees(dealerData);

	}, [dealerData]);

	const getFeeDetails = (price) => {
		return feeDetails.length > 0 ? feeDetails
			.filter((data) => {
				const range = data.from_price
				const rangeOne = data.to_price

				if (range[1] !== "up") {

					return Number(range) <= Number(price) && Number(price) <= Number(rangeOne)
				}
				else {
					return Number(range) <= Number(price)
				}

			}
			)[0]?.fee || 0
			: 0
	}

	function formatTime(value) {
		let local = ""
		let offset = ""
		local = new Date(value);
		offset = local.getTimezoneOffset();
		value = new Date(local.getTime() - offset * 60000);
		value = moment(value).format('MMMM D, YYYY hh:mm A')
		return value;
	}

	const handleBackButton = () => {

		history.push({
			pathname: back,
			state: { BillofSale: carDetail[0].bill_of_sale_id, CarId: carDetail[0].car_id },
		});
		ls.set("backredirection", backUrl.slice(0, -1))

	}

	const [showPopover, setShowPopover] = useState(Array(carDetail.length).fill(false));
	const [carPrice, setCarPrice] = useState("")

	const handleBackButtonClick = (index, item) => {
		console.log(item, "item");
		setShowPopover(prevShowPopover => {
			const newShowPopover = [...prevShowPopover];
			newShowPopover[index] = !newShowPopover[index];
			return newShowPopover;
		});
		setCarPrice(item)
	}

	const totalPrice = Number(carPrice.max_price) -
		(Number(carPrice?.bos_seller_fee) +
			Number(carPrice?.bos_sellerothertotalcharges) +
			Number(carPrice?.bos_car_charges));

	const popover = (
		<Popover id="popover-basic" className="custom-popover">
			<Popover.Title as="h3">Vehicle Price</Popover.Title>
			<Popover.Content >
				<div className="row">
					<div class="col-lg-12 pt-4 pt-lg-0 feestableBlock">
						<div class="feestable">
							<p>Price - <span>$ {carPrice.max_price}</span></p>
							<p>Sell Fee - <span>$ {carPrice.bos_seller_fee}</span></p>
							<p>Other Charges - <span>$ {carPrice.bos_sellerothertotalcharges}</span></p>
							<p>Miscellaneous Charges - <span>$ {carPrice.bos_car_charges}</span></p>
							<p>Total Price - <span>$ {totalPrice}</span></p>


						</div>
					</div>
				</div>
			</Popover.Content>
		</Popover>
	);

	return (


		<main id="main" class="inner-page">
			{loading ? <Loading /> :
				<div id="products-details" class="products-details">

					{errorFlag === true ? <PageNotFound error={errors} /> :
						<div class="container-fluid inner-page-space">
							<div class="back-btn">
								<a class="back-btn-primary" onClick={() => handleBackButton()}><i class="bx bx-chevron-left"></i> Back</a>
							</div>
							<div class="row">
								{carDetail.length > 0 &&
									<div class="col-lg-6">
										<div class="vehicle-detail-banner banner-content clearfix">
											<div class="banner-slider">
												<div class="slider slider-for">
													<div class="slider-banner-image">
														<div
															style={{ position: "relative", cursor: "crosshair", display: "inline-block", width: "100%" }}
															onMouseMove={(e) => handleMouseMove(e, "large")}
															onMouseLeave={handleMouseLeave}
															onClick={() => handleImageClick(lrgImg, 0)}
														>
															{isVideoFlag === false
																? <img
																	src={lrgImg}
																	alt="no image"
																	width="390px"
																	height="470px"
																	style={{ display: 'block', width: '100%', height: 'auto', cursor: 'crosshair' }}
																/>
																: <video key={lrgVideo} autoBuffer controls width="390px" height="470px" style={{ width: '100%', height: 'auto' }}>
																	<source className="card-img-top" src={lrgVideo} type="video/mp4" />
																</video>
															}
															{cardMagnifier.show && cardMagnifier.activeId === "large" && (
																<div
																	className="magnifier-image"
																	style={{
																		left: `${cardMagnifier.x}px`,
																		top: `${cardMagnifier.y}px`,
																		backgroundImage: `url(${lrgImg})`,
																		backgroundPosition: `${cardMagnifier.imgX}% ${cardMagnifier.imgY}%`,
																	}}
																/>
															)}
														</div>
													</div>
												</div>

												<div className="slider slider-nav thumb-image">
													{carDetail.length > 4 && (
														<button className="arrow up" onClick={scrollUp}>▲</button>
													)}
													<div className="thumb-scroll-container" ref={sliderRef}>
														{carDetail.slice(1).map((item, index) => (
															<div className="thumbnail-image" key={item.car_images_id || index}>
																<div
																	className="thumbImg"
																	style={{ cursor: "pointer" }}
																	onClick={() => {
																		if (item?.format === "video") {
																			setLrgVideo(item?.carimage);
																			setIsVideoFlag(true);
																		} else {
																			setLrgImg(item?.carimage);
																			setIsVideoFlag(false);
																		}
																		handleImageClick(item?.carimage, index + 1); 
																	}}
																>
																	{item?.format === "video"
																		? <video autoBuffer controls width="100%" height="100%">
																			<source id="mp4" className="card-img-top" src={item?.carimage} type="video/mp4" />
																		</video>
																		: <img src={item?.carimage} alt="" width="100%" height="100%" style={{ cursor: 'pointer' }} />
																	}
																</div>
															</div>
														))}
													</div>
													{carDetail.length > 4 && (
														<button className="arrow down" onClick={scrollDown}>▼</button>
													)}
												</div>
											</div>
										</div>
									</div>}

								{carDetail.length > 0 &&
									<div class="col-lg-6">
										<div class="product-dtl">
											<div class="cars-detail-inside">
												<div class="cars-detail-views">
													<p class="car-btns"><span className="greytext">Inventory # : </span> {carDetail[0].car_id}</p>
												</div>
											</div>
											<div class="product-info">
												<div class="product-name">
													<p>
														{carDetail[0].year} {carDetail[0].make} {carDetail[0].model}</p>
												</div>
												{/* <div className='cars-popover'>

													<OverlayTrigger
														trigger="click"
														placement="top"
														show={showPopover[carDetail[0].car_id]}
														overlay={popover}
													>
														<Button onClick={() => handleBackButtonClick(carDetail[0].car_id, carDetail[0])} variant="primary">Click </Button>
													</OverlayTrigger>

												</div> */}
												<div class="km-petrol">
													<p class="details"><img src={speedometer} alt="" /><span>{carDetail[0].mileage} {carDetail[0]?.mileage_type}</span></p>&nbsp;&nbsp;&nbsp;&nbsp;
													{carDetail[0].fuel_type == "null" || carDetail[0].fuel_type == "" || carDetail[0].fuel_type == null || carDetail[0].fuel_type == undefined || carDetail[0].fuel_type == "undefined" ? "" :
														<p class="details"><img src={gasolinePump} alt="" /><span>{carDetail[0].fuel_type}</span></p>}
													<a class="labeltype"><span>{carDetail[0].label_type === "Sealed Bid Sales" ? carDetail[0].label_type.substr(0, 10) : carDetail[0].label_type}</span></a>
												</div>

												<p class="odometer"><span className="label">Is Odometer working</span> : {carDetail[0].odometer}</p>

												{carDetail[0].dealer_message == "" || carDetail[0].dealer_message == "undefined" || carDetail[0].dealer_message == null || carDetail[0].dealer_message == "null" ? <p><span class="dealertaglines">Message From The Dealer : </span>No Message</p> :
													<p><span class="dealertaglines">Message From The Dealer : {carDetail[0].dealer_message}</span></p>}
											</div>
											<div class="row vinqr">
												<div class="col-md-12 carpoints">
													<div className="label">Vin # : </div>
													<div class="carpoint">
														<img src={car} alt="" />
														<span>{carDetail[0].vin_no}</span>
														<CopyToClipboard text={carDetail[0].vin_no} onCopy={() => setCopied(true)}>
															<span title="Copy" onClick={copytoclipboard} className="copyImg"><i class="icofont-copy"></i></span>
														</CopyToClipboard>
														<img src={barcode} alt="" onMouseEnter={() => setIsShown(true)} onMouseLeave={() => setIsShown(false)} />
													</div>

												</div>
												{isShown && (
													<div>
														<Barcode value={carDetail[0].vin_no} {...config} />
													</div>
												)}
											</div>

											<div class="title-status">
												<p className="title-label">Title status :<span className='tit-sold'></span>
													<div className={`${carDetail[0]?.title === "Title" ? "title-cart" : carDetail[0]?.title === "Title Attached" ? "titleattached-cart" : carDetail[0]?.title === "Bill of sale only" ? "billofsale-cart" : ""}`}>{carDetail[0]?.title}</div>
												</p>
											</div>



											<div class="">
												<div class="titlestatus-1">
													{carDetail[0].ach_date == "" || carDetail[0].ach_date == undefined || carDetail[0].ach_date == null ? <p>Date of fund : <span class="redText">Not yet</span></p> :
														<p> Date of fund : <span class="greenText">{carDetail[0]?.ach_date}</span></p>}
												</div>
												<div class="titlestatus-2">
													{/* {carDetail[0].transportation_status_name == "" || carDetail[0].transportation_status_name == undefined || carDetail[0].transportation_status_name == null ? <p>Date of fund : <span class = "redText">Not yet</span></p>: */}
													<p><span>Sold Status : </span>{carDetail[0]?.transportation_status_name}</p>
												</div>
											</div>




											<div class="custom-button-accept">
												{carDetail[0].sold_price == "" || carDetail[0].sold_price == undefined || carDetail[0].sold_price == null ? "" :
													<>
														<a class="car-btns redBtn" onClick={() => {
															history.push({
																pathname: "/invoice",
																state: {
																	backURL: "/soldcardetails", billOfSales: carDetail[0].bill_of_sale_id, make: carDetail[0].make, model: carDetail[0].model, gatePass: carDetail[0].gatepass_code, year: carDetail[0].year, buyerId: carDetail[0].buyer_dealer_id, price: carDetail[0].sold_price, soldDate: formatTime(carDetail[0].sold_date_tz), VinNo: carDetail[0].vin_no, inventoryNo: carDetail[0].car_id,
																	achDate: carDetail[0].ach_date_tz == "" || carDetail[0].ach_date_tz == undefined || carDetail[0].ach_date_tz == null ? "" : formatTime(carDetail[0].ach_date_tz),
																	selectedValues: carDetail[0]
																}
															})
														}} >Net Amount : <span class=""> $ {Number(carDetail[0].sold_price) - Number((carDetail[0].bos_seller_fee) + Number(carDetail[0].bos_car_charges) + Number(carDetail[0].bos_sellerothertotalcharges))}</span></a>
														{carDetail[0].bill_of_sale_id !== null ?
															<a class="car-btns redBtn" onClick={() => {
																history.push({ pathname: "/billofsale", state: { backURL: "/soldcardetails", BillofSale: carDetail[0].bill_of_sale_id, CarId: carDetail[0].car_id } }); ls.set("backredirection", [...backUrl, "/soldcardetails"])
															}} >Bill of Sale # : <span class=""> {carDetail[0].bill_of_sale_id}</span></a> :

															<a class="car-btns redBtn">Bill of Sale # : <span class=""> {carDetail[0].bill_of_sale_id}</span></a>}
													</>}
											</div>


											<div class="invoice_link">
												<a class="redBtn"
													onClick={() => history.push({
														pathname: "/invoice",
														state: {
															backURL: "/soldcardetails",
															billOfSales: carDetail[0].bill_of_sale_id, make: carDetail[0].make, model: carDetail[0].model, gatePass: carDetail[0].gatepass_code, year: carDetail[0].year, buyerId: carDetail[0].buyer_dealer_id, price: carDetail[0].sold_price, soldDate: formatTime(carDetail[0].sold_date_tz), VinNo: carDetail[0].vin_no, inventoryNo: carDetail[0].car_id,
															// achDate: carDetail[0].ach_date,
															achDate: carDetail[0].ach_date_tz == "" || carDetail[0].ach_date_tz == undefined || carDetail[0].ach_date_tz == null ? "" : formatTime(carDetail[0].ach_date_tz),
															selectedValues: carDetail[0]
														}
													})}>Invoice</a>
											</div>



											<div class="sold-car-qr">
												<div class="gatepass soldgatepass">
													{/* <a class="cta-btns" >Price - ${item.price}</a> */}
													{carDetail[0].gatepass_id == null || carDetail[0].gatepass_id == "" || carDetail[0].gatepass_id == undefined ?
														<a class={`cta-btns-primary gatepasscodeqrgen ${(carDetail[0].transportation_flag == 2) && "redBtn"}`}  >Gate Pass Code : {carDetail[0].gatepass_id}</a> :
														<a class={`cta-btns-primary gatepasscodeqrgen ${(carDetail[0].transportation_flag == 2) && "redBtn"}`} onClick={() => { carDetail[0].transportation_flag == 1 && gatePass(carDetail[0]) }} >Gate Pass Code : {carDetail[0].gatepass_code}</a>}
												</div>
												<>
													{carDetail[0].gatepass_id == null || carDetail[0].gatepass_id == "" || carDetail[0].gatepass_id == undefined ? "" :
														<div className='soldgp-code'>
															<img className='soldgpcode' src={barcode} alt="" onMouseEnter={() => setIsShowngp(true)} onMouseLeave={() => setIsShowngp(false)} />
														</div>}
												</>
												{isShowngp && (
													<div>
														<Barcode value={carDetail[0].gatepass_code} {...config} />
													</div>
												)}
											</div>

											<div class="cars-detail-ins">
												<a class="cars-buy-btns redBtn" onClick={() => { togglePopupBidList() }} >Bid Details</a>
												<a class="cars-buy-btns redBtn butnpad" onClick={() => { togglePopupProxyList() }}  >Proxy Bid Details</a>
											</div>

										</div>
									</div>}
							</div>
						</div>}
				</div>}
			<section id="playstoreBlock" class="playstoreBlock">
				<div class="container">
					<div class="row content">
						<div class="col-lg-12">
							<img src={appstore} />
							<img src={googleplay} />
						</div>
					</div> </div>
			</section>
			{isOpenBidList && <Popup
				isClose={false}
				content={<>
					<UrCarBidList toggle={togglePopupBidList} /* buyerDealerId={buyerDealerId} highBid={highBid} sellitNow={sellitNow}  *//* counterBitUpdateFlag={counterBitUpdateHandler} */ carId={carDetail[0].car_id}/*  time={time} countBid={countBid} newBid={newBid} */ handleCounter={handleCounter} />
				</>}
				handleClose={togglePopupBidList}
			/>}
			{isOpenProxyList && <Popup
				isClose={false}
				content={<>
					<UrCarProxyList toggle={togglePopupProxyList} /* buyerDealerId={buyerDealerId} highBid={highBid} sellitNow={sellitNow}  *//* counterBitUpdateFlag={counterBitUpdateHandler} */ carId={carDetail[0].car_id}/*  time={time} countBid={countBid} newBid={newBid} */ handleCounter={handleCounter} />
				</>}
				handleClose={togglePopupProxyList}
			/>}
			{isOpenAccept && <Popup
				isClose={false}
				content={<>
					<GatePassAccept toggle={togglePopupAccept} carId={carId} buyerId={buyerId} gatepassColorChange={gatepassColorChange} />
				</>}
				handleClose={togglePopupAccept}
			/>}
			{isPopupOpen && (
    <PopupMagnifier
        images={popupImages}
        currentIndex={currentImageIndex}
        onClose={() => setIsPopupOpen(false)}
        onNext={handleNextImage}
        onPrev={handlePrevImage}
    />
)}
		</main>
	)
}
export default CarDetails;